import { Link } from '@reach/router';
import React, { Component, ReactNode } from 'react';
import './list.less';
import { List } from '@nackle/paper';
interface SharedListProps<T> {
    readonly getList: () => void;
    readonly list: Array<T>;
    readonly idKey: string;
    readonly notFoundMessage: ReactNode;
}

export default class SharedList<T> extends Component<SharedListProps<T>> {
    static defaultProps = {
        idKey: 'id',
        list: {}
    };

    constructor(props) {
        super(props);
        this.props.getList();
    }

    render() {
        const { list, idKey, notFoundMessage } = this.props;
        const listKeys = Object.keys(list).sort();
        const hasListKeys = !!listKeys.length;
        return (
            <section className="section">
                { hasListKeys && listKeys.map(key => 
                    <>
                        <div className="nkl-mb-2">
                            <h4>{key}</h4>
                            <List 
                                dataSource = {list[key]} 
                                renderItem={ (item: {name: string}) => <List.Item><Link to={`./${item[idKey]}/update`}>{item?.name}</Link></List.Item> } 
                            />
                        </div>
                    </>
                ) }
                {
                    !hasListKeys &&
                    <div className="col no-list-found">
                        {notFoundMessage}
                    </div>
                }
            </section>
        );
    }
}
